<template>
  <div class="ChartList">
    <div v-for="item in list.data" :key="item">
      <g-drag-resize :config="dragConfig(item)">
        <template #default>
          <Chart v-if="item.checkbox" :dataObj="item" @close="() => onClose(item)" />
        </template>
      </g-drag-resize>
    </div>
    <div>
      <div class="item" v-for="item in list.data" :key="item">
        <el-checkbox size="small" v-model="item.checkbox" @change="() => saveOpenState(item, item.checkbox)">
          <span style="color: #fff;">{{ item.name }}</span>
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, watch } from "vue";
import Chart from "../Chart/index.vue";
import { useFrameDataStore } from "@/store/frameDataStore";
export default defineComponent({
  name: "ChartList",
  components: {
    Chart,
  },
  setup() {
    const list = reactive<any>({
      data: [],
    });
    const frameDataStore = useFrameDataStore()
    const saveOpenState = (item: any, val: any) => {
      const key = 'echart_' + item.name
      const local = JSON.parse(localStorage.getItem(key) || '{}')
      local.isOpen = val
      localStorage.setItem(key, JSON.stringify(local))
    }
    const onClose = (item: any) => {
      item.checkbox = false
      saveOpenState(item, false)
    }
    const dragConfig = (item: any) => {
      let localConfig: any = localStorage.getItem('echart_' + item.name) || "{}"
      localConfig = JSON.parse(localConfig)
      let w = localConfig.w || 700
      let h = localConfig.h || 300
      let x = localConfig.x * window.innerWidth || item.x || 0
      let y = localConfig.y * window.innerHeight || item.y || 50
      return {
        minW: 300,
        minH: 200,
        w,
        h,
        x,
        y,
        isShow: item.checkbox,
        nameSpace: 'echart_' + item.name,
        active: false
      };
    };
    watch(()=>frameDataStore.currentTimeInterval, (e) => {
      list.data = []
    })
    watch(()=>frameDataStore.currentData, (e: any) => {
      if (e?.vehicleData?.metricDataFrameList) {
        e?.vehicleData?.metricDataFrameList.forEach((v: any) => {
          const obj = list.data.find((l: any) => l.name == v.metricName)
          if (!obj) {
            const autoOpen = JSON.parse(localStorage.getItem('autoOpenChart') ?? 'false')
            const localConfig = JSON.parse(localStorage.getItem('echart_' + v.metricName) || '{}')
            list.data.push({
              name: v.metricName,
              checkbox: autoOpen && !!localConfig.isOpen,
              data: v,
            });
          }
        })
      }
    });

    return {
      list,
      dragConfig,
      saveOpenState,
      onClose,
    };
  },
});
</script>
<style lang="less" scoped>
.ChartList {
  height: 160px;
  font-size: 12px;
  border-radius: 5px;
  margin: 5px;
  box-sizing: border-box;
  overflow-y: scroll;
}

.scroll {
  height: 100%;
  border-radius: 5px;
}

.item {
  padding: 2px 5px;
  cursor: pointer;
  /* overflow: hidden; */
  display: flex;
  align-items: center;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);

  .text {
    word-break: break-all;
    padding-left: 4px;
  }
}

.el-checkbox {
  --el-checkbox-font-color: #fff;
  --el-color-primary: var(--theme);
}

.vdr-container {
  cursor: move;
}

:deep(.Chart) {
  cursor: default;
}

:deep(.Chart-box) {
  background-color: var(--el-color-primary);
}
</style>
